import React from 'react';
import { isJpgImage } from '../../../../utils/imageHelpers';
import useImageIntentFriction from '../../shared/protectedImage/useImageIntentFriction';
import { imageIntentGalleryOf } from '../../shared/protectedImage/imageIntentGallery';
import {
  ProductItem,
  ProductItemWrapper,
  ProductItemName,
} from './multiConfigStyles';
import { useSelector } from 'react-redux';
import { childIsConfigurable, childIsConfigured } from './childConfiguration';
import MultiConfigProductItemCTA from './MultiConfigProductItemCTA';

const MultiConfigProductItem = ({ item, onClick }) => {
  const isPrepay = useSelector((state) => state.shoot.isPrepay);
  const { getFrictionProps } = useImageIntentFriction({
    surface: 'multi_config',
  });
  const { product, background, pose } = item;
  // Don't show background behind JPG poses - they don't have alpha transparency
  const isJpg = pose?.url && isJpgImage(pose.url);
  const backgroundOptionStyle =
    background && !isJpg
      ? {
          backgroundImage: `url(${background?.image_thumbnail})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }
      : {};

  const isConfigurable = childIsConfigurable(product, { isPrepay });

  // Only the chosen-pose thumbnail shows the child; the fallback tile renders
  // `product.image_thumbnail`, which is catalogue artwork.
  // The chosen pose may be one pooled from a sibling gallery, which carries
  // its own gallery; otherwise the hook's Redux gallery applies.
  const poseContext = {
    ...imageIntentGalleryOf(pose),
    surface: 'multi_config',
    imageKey: pose?.url || `product-${product?.id}`,
  };

  return (
    <ProductItemWrapper>
      <ProductItem
        style={{
          ...backgroundOptionStyle,
          ...(isConfigurable ? {} : { cursor: 'unset' }),
        }}
        onClick={isConfigurable ? onClick(product) : null}
      >
        {pose ? (
          <img
            src={pose.url}
            {...getFrictionProps(poseContext)}
            alt="Overlay Pose"
          />
        ) : (
          !background &&
          product.image_thumbnail && (
            <img src={product.image_thumbnail} alt={product?.name} />
          )
        )}
        {isConfigurable && (
          <MultiConfigProductItemCTA item={item} onClick={onClick} />
        )}
      </ProductItem>
      <ProductItemName>{`${childIsConfigured(item, { isPrepay }) ? '✅ ' : ''}${
        product?.name
      }`}</ProductItemName>
    </ProductItemWrapper>
  );
};

export default MultiConfigProductItem;
